// 初始化过程中的一些状态值
export const initialProcessState: any = {
    recommendOffer: null
};

export const updateProcessState: any = (payload: any) => {
    const {key, offer} = payload;
    initialProcessState[key] = offer;
};
